import ResendUnusualAccessError from './ResendUnusualAccessError';
class TraderIsNotBlocked extends ResendUnusualAccessError {
    constructor(emailAddress, options) {
        super(`The email address '${emailAddress}' is not blocked`, options);
    }
}
export default TraderIsNotBlocked;
